import React, { useEffect } from 'react'
import * as Yup from 'yup'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { OptionsCompoentt, TextAreaInput, TextInputComponent, CategoryOptionsCompoent } from '../../../common/Form/Input.component'

const CollectionForm = ({ submitEvent, loading, value, detail = null }) => {

    const collectionDTO = Yup.object({
        name: Yup.string().min(3).max(50).required(),
        description: Yup.string().min(3).nullable().optional().default(null),
        status: Yup.object({
            label: Yup.string().matches(/^(Active|Inactive)$/),
            value: Yup.string().matches(/^(active|inactive)$/).required()
        }).required(),
        category: Yup.object({
            label: Yup.string().matches(/^(Image|Video)$/),
            value: Yup.string().matches(/^(image|video)$/).required()
        }).required(),
        image: Yup.mixed().nullable().notRequired(),
        video: Yup.mixed().nullable().notRequired(),
    })

    const { control, handleSubmit, setValue, watch, formState: { errors } } = useForm({
        resolver: yupResolver(collectionDTO)
    })

    const selectedCategory = watch('category')?.value || detail?.category?.value || (detail?.category === 'video' ? 'video' : 'image')

    useEffect(() => {
        if (detail) {
            setValue("name", detail.name)
            setValue("description", detail.description)
            setValue("status", detail.status)
            setValue("category", detail.category)
            setValue("image", detail.image || detail.desktopImage)
            setValue("video", detail.video || detail.desktopVideo)
        }
    }, [detail, setValue])

    return (
        <form onSubmit={handleSubmit(submitEvent)}>
            <h3>Content</h3>
            <div className="from_grid">
                <div>
                    <label htmlFor="name">Collection Name</label><br />
                    <TextInputComponent
                        name="name"
                        control={control}
                        type='text'
                        defaultValue=''
                        errMsg={errors?.name?.message}
                        required:true
                    />
                </div>
                <div>
                    <label htmlFor="description">Description</label><br />
                    <TextAreaInput
                        name="description"
                        control={control}
                        defaultValue=''
                        errMsg={errors?.content?.message}
                    />
                </div>
                <div>
                    <label htmlFor="category">Category</label><br />
                    <CategoryOptionsCompoent 
                        name="category"
                        control={control}
                        errMsg={errors?.category?.message}
                        required:true                    
                    />
                </div>
                <div>
                    <label htmlFor="status">Status</label><br />
                    <OptionsCompoentt
                        name="status"
                        control={control}
                        errMsg={errors?.status?.message}
                        required:true
                    />
                </div>

                {/* Show Image input if category is Image or not chosen yet */}
                {selectedCategory !== 'video' && (
                    <div>                
                        <label htmlFor="image">Collection Image</label><br />
                        <input
                            type='file'
                            accept='image/*'
                            onChange={(e) => {
                                const file = e.target.files['0']
                                setValue('image', file)
                            }}
                        /><br />
                        {detail?.image && typeof detail.image === 'string' && (
                            <div style={{ marginTop: '8px' }}>
                                <small>Current Image: </small>
                                <img src={detail.image} alt="current" style={{ width: '80px', height: '60px', objectFit: 'cover', borderRadius: '4px' }} />
                            </div>
                        )}
                    </div>
                )}

                {/* Show Video input if category is Video */}
                {selectedCategory === 'video' && (
                    <div>
                        <label htmlFor="video">Collection Video</label><br />                
                        <input
                            type='file'
                            accept='video/*'
                            onChange={(e) => {
                                const file = e.target.files['0']
                                setValue('video', file)
                            }}
                        /><br />
                        {detail?.video && typeof detail.video === 'string' && (
                            <div style={{ marginTop: '8px' }}>
                                <small>Current Video: </small>
                                <video src={detail.video} style={{ width: '120px', height: '60px', objectFit: 'cover', borderRadius: '4px' }} muted controls />
                            </div>
                        )}
                    </div>
                )}
            </div>

            <div style={{ display: 'flex', justifyContent: 'center' }}>            
                <input className='submit_btn' type="submit" value={value} disabled={loading} style={{ cursor: 'pointer' }} />
            </div>
        </form>
    )
}

export default CollectionForm